define("ember-svg-jar/inlined/social-listening", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<g clip-path=\"url(#a)\"><path d=\"M2.333 3.5v22.167L7 21h18.667V3.5H2.333zm7.654 9.987a1.767 1.767 0 01-2.497 0 1.767 1.767 0 010-2.497 1.767 1.767 0 012.497 0 1.767 1.767 0 010 2.497zm5.891 0a1.768 1.768 0 01-2.496 0 1.768 1.768 0 010-2.497 1.768 1.768 0 012.496 0 1.768 1.768 0 010 2.497zm5.892 0a1.767 1.767 0 01-2.497 0 1.767 1.767 0 010-2.497 1.767 1.767 0 012.497 0 1.767 1.767 0 010 2.497z\"/></g><defs><clipPath id=\"a\"><path d=\"M0 0h28v28H0z\"/></clipPath></defs>",
    "attrs": {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "28",
      "height": "28",
      "fill": "currentColor",
      "viewBox": "0 0 28 28"
    }
  };
});